<template>
  <component :is="NavbarComp">
    <BookingToastHost />

    <div
      v-if="isSimpleLoading || !authReady"
      class="vtmn-absolute vtmn-z-50 vtmn-left-[50%] vtmn-top-[50%] -vtmn-translate-x-1/2 -vtmn-translate-y-1/2"
    >
      <DecathlonLoader size="large" />
      <span class="vtmn-sr-only">{{ $t("loading") }}</span>
    </div>

    <div v-if="authReady" class="vtmn-p-2 vtmn-bg-gray-50 vtmn-h-full">
      <router-view />
    </div>
  </component>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import NavbarComp from "./components/molecules/NavbarComp.vue";
import BookingToastHost from "./modules/bookingsModule/components/shared/BookingToastHost.vue";
import fedidService from "./modules/oauth/services/FedidService";
import useAuth from "./modules/oauth/composables/useAuth";
import useHda from "./composables/useHda";
import { useI18n } from "vue-i18n";

import DecathlonLoader from "@/components/atoms/DecathlonLoader.vue";

useI18n();

const authReady = ref(false);

onMounted(async () => {
  await fedidService.getTokenAndSaveData();
  const { loginState, accessToken } = useAuth();
  authReady.value = loginState.value && !!accessToken.value;
});

const { isSimpleLoading } = useHda();
</script>
